import { Group } from '@mantine/core'
import { first, get, noop, size } from 'lodash'
import React from 'react'
import { ReactNode } from 'react'
import { Container } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import styled from 'styled-components'

import LanguageSelect from '../../LanguageSelect'
import { TTheme } from '../../ThemeContext'
import Item, { TItemNavbar } from './Item'

type TWrapper = {
  backgroundColor?: string
  isToggled?: boolean
}
const Wrapper = styled.div<TWrapper>`
  background-color: ${({ backgroundColor }) => backgroundColor};

  @media (max-width: 767px) {
    display: ${({ isToggled }) => (isToggled ? 'block' : 'none')};
  }
`

type TInnerWrapper = {
  centered?: boolean
  maxLevelDumpsterFireDispo: boolean
}

const InnerWrapper = styled.div<TInnerWrapper>`
  display: flex;
  justify-content: ${({ centered }) => (centered ? 'center' : 'flex-start')};
  align-items: stretch;
  margin: 0 -20px;
  flex-wrap: wrap;
  flex-grow: ${({ maxLevelDumpsterFireDispo }) =>
    maxLevelDumpsterFireDispo ? 1 : 0};
  @media (max-width: 767px) {
    flex-direction: column;
    max-height: 80vh;
    overflow-y: auto;

    & .dropdown-menu.show {
      position: relative;
      left: 10px;
      width: calc(100% - 20px);
    }
  }
`

type TNavbar = {
  centered?: boolean
  fluid?: boolean
  items?: TItemNavbar[]
  theme?: TTheme
  isToggled?: boolean
  coloredHeader?: boolean
  replaceTo?: string
  onLinkClick?: () => void
  showLanguageSelect?: boolean
  centerItems?: ReactNode[]
  topPushEnabled?: boolean
  maxLevelDumpsterFireDispo?: ReactNode
  isCompact?: boolean
}
const Navbar = (props: TNavbar): React.ReactElement => {
  const {
    centered,
    fluid,
    items = [],
    theme = {},
    isToggled,
    coloredHeader,
    replaceTo,
    onLinkClick = noop,
    showLanguageSelect,
    centerItems,
    topPushEnabled = false,
    maxLevelDumpsterFireDispo,
    isCompact,
  } = props

  const Lang = showLanguageSelect && (
    <MediaQuery maxWidth={767}>
      <div className="mx-3 mb-1 mt-2">
        <LanguageSelect />
      </div>
    </MediaQuery>
  )

  const Center = centerItems && (
    <MediaQuery maxWidth={767}>{centerItems}</MediaQuery>
  )

  const Items = items
    .filter(Boolean)
    .filter((item) => item.show !== false)
    .filter(
      (item) =>
        item.onClick ||
        item.to ||
        item.href ||
        size(get(item, 'children', []) || []) > 0,
    )
    .map((item, index) => {
      const children = get(item, 'children', []) || []
      return (
        <Item
          {...(size(children) === 1 && topPushEnabled ? first(children) : item)}
          theme={theme}
          replaceTo={replaceTo}
          onClick={onLinkClick}
          onClickProp={get(item, 'onClick')}
          disabled={item.disabled}
          key={index}
          isCompact={isCompact}
        />
      )
    })

  const DefaultInner = (
    <>
      {Center}
      {Lang}
      {Items}
    </>
  )

  const validMaxLevelDumpsterFireDispo =
    React.isValidElement(maxLevelDumpsterFireDispo) ||
    typeof maxLevelDumpsterFireDispo === 'string'

  return (
    <Wrapper
      backgroundColor={coloredHeader ? 'white' : theme.backgroundColor}
      isToggled={isToggled}
    >
      <Container fluid={fluid}>
        <InnerWrapper
          centered={!isToggled && centered}
          maxLevelDumpsterFireDispo={validMaxLevelDumpsterFireDispo}
        >
          {validMaxLevelDumpsterFireDispo ? (
            <Group position="apart" style={{ flex: 1 }}>
              <div style={{ display: 'flex' }}>{DefaultInner}</div>

              {maxLevelDumpsterFireDispo}
            </Group>
          ) : (
            <>{DefaultInner}</>
          )}
        </InnerWrapper>
      </Container>
    </Wrapper>
  )
}

export default Navbar
